import styled from 'styled-components'

export const ManageCurrencyListLinkStyled = styled.a`
  font-weight: 400;
  white-space: nowrap;
`
